export default __webpack_public_path__ + "static/media/Banner-Resenas-1-estimulos.630cc3a5.jpg";